module.exports = __webpack_public_path__ + "assets/bugherd.ec66961a.svg";